import React from 'react';
import { Link } from 'react-router-dom';

// Renders chat text with **bold**, [label](url) and bare URLs as links
const TOKEN = /(\[[^\]]+\]\((?:https?:\/\/|\/)[^\s)]+\)|\*\*[^*]+\*\*|https?:\/\/[^\s)]+)/g;

const renderLink = (label, href, key, isUser) => {
  const cls = `underline font-semibold ${isUser ? 'text-white' : ''}`;
  const style = isUser ? undefined : { color: '#D97904' };
  if (href.startsWith('/')) {
    return <Link key={key} to={href} className={cls} style={style} data-testid="chat-internal-link">{label}</Link>;
  }
  return <a key={key} href={href} target="_blank" rel="noopener noreferrer" className={cls} style={style}>{label}</a>;
};

const ChatMessageText = ({ text, isUser }) => {
  const parts = text.split(TOKEN);
  return (
    <p className="text-sm whitespace-pre-wrap">
      {parts.map((part, i) => {
        if (!part) return null;
        const md = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (md) return renderLink(md[1], md[2], i, isUser);
        if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
        if (/^https?:\/\//.test(part)) return renderLink(part, part, i, isUser);
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </p>
  );
};

export default ChatMessageText;
